<template>
  <Popover
    ref="popoverRef"
    position="br"
    trigger="click"
    arrowClass="hidden"
    class="export-activity-popper"
    contentClass="p-0"
    :content-style="{ width: '380px' }"
  >
    <slot />
    <template #content>
      <div class="export-activity-title justify-between items-center border-solid border-0 border-white/10 border-b">
        <div>{{ $t('TD1095') }}</div>
        <div>
          <button
            @click="closePopover"
            class="bg-transparent"
          >
            <i class="iconfont iconicon_jichutubiao_guanbi text-white/50"></i>
          </button>
        </div>
      </div>
      <ul class="export-activity__file-wrapper">
        <li
          v-for="fileType in fileTypes"
          :key="fileType"
          class="export-activity__file-type bg-white/5 cursor-pointer"
          @click="handleExport(fileType)"
        >
          <div class="export-activity__file-type-icon leading-none">
            <i
              class="iconfont text-white"
              :class="map4fileTypes[fileType].icon"
            ></i>
          </div>
          <div>
            <div class="export-activity__file-type-title text-white">
              {{ $t(map4fileTypes[fileType].title) }}
            </div>
            <div class="export-activity__file-type-desc text-white/60">
              {{ $t(map4fileTypes[fileType].desc) }}
            </div>
          </div>
        </li>
      </ul>
      <p class="export-activity-footer text-white/60">{{ $t('C4012') }}</p>
    </template>
  </Popover>
</template>

<script setup>
import { ref } from 'vue';
import { Message, Popover } from '@arco-design/web-vue';
import { downloadFile } from '@client/helper/file';
import { activity } from '@client/api/index';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const popoverRef = ref(null);

const props = defineProps({
  labelId: {
    type: String,
    default: ''
  },
  sportType: {
    type: String,
    default: ''
  },
  fileTypes: {
    type: Array,
    default: () => [],
    required: true
  }
});

const map4fileTypes = {
  4: {
    icon: 'iconfit',
    title: 'C4002',
    desc: 'C4003'
  },
  3: {
    icon: 'icontcx',
    title: 'C4004',
    desc: 'C4005'
  },
  2: {
    icon: 'iconkml',
    title: 'C4008',
    desc: 'C4009'
  },
  1: {
    icon: 'icongpx',
    title: 'C4006',
    desc: 'C4007'
  },
  0: {
    icon: 'iconcsv',
    title: 'C4010',
    desc: 'C4011'
  }
};

const emit = defineEmits(['close']);
const closePopover = () => {
  emit('close');
};
const handleExport = (fileType) => {
  const { labelId, sportType } = props;
  const options = {
    url: '/activity/detail/download',
    params: {
      labelId,
      sportType: Number(sportType),
      fileType
    }
  };

  activity
    .api4ActivityDownload(options)
    .then(({ data }) => {
      const { fileUrl } = data.value;
      // 如果fileUrl不返回或者fileUrl为空,表示该运动不支持下载
      if (!fileUrl) {
        Message.error(t('H1210'));
        return;
      }
      downloadFile(fileUrl);
    })
    .catch((err) => {
      console.error(err);
    })
    .finally(() => {
      closePopover();
    });
};
</script>

<style lang="scss" scoped>
@import '@client/styles/_mixins.scss';

.export-activity-popper {
  padding: 0;

  .export-activity-title {
    display: flex;
    font-size: 16px;
    font-weight: 500;
    padding-inline: 24px;
    padding-block: 16px;
    color: #fff;
  }

  .export-activity__file-type {
    display: flex;
    border-radius: 4px;
    margin-top: 8px;
    padding: 8px;
    font-size: 14px;

    &:first-child {
      margin-top: 0;
    }

    .export-activity__file-type-icon {
      margin-right: 12px;
      padding-top: 6px;
    }

    .iconfont {
      font-size: 1.72em;
    }

    .export-activity__file-type-title {
      line-height: 1.425;
    }

    .export-activity__file-type-desc {
      font-size: 0.85em;
      line-height: 1.5;
      margin-top: 0.33em;
    }
  }

  .export-activity__file-wrapper {
    margin: 16px;
  }

  .export-activity-footer {
    font-size: 12px;
    padding: 0 2em 2em 2em;
    line-height: 1.5;
  }
}
</style>
